import axios from 'axios';

import { API_URL } from './baseApi';

export const brandsApi = {
  getBrandsGames: async () => {
    return await axios.get(`${API_URL}/v1/games/sections`);
  },
};
